module.exports = __webpack_public_path__ + "media/application/images/svgs/video-f4a4d38d788429774e012cca831ae2e8.svg";